import { RoutingFlowContainer } from "#/components/carrot-plans/shared/RoutingFlowContainer"
import { StateMachineProvider, StateMachineStepView } from "#/components/context/stateMachine/StateMachineV2"
import { useBodyClass } from "#/utils/Hooks"
import React from "react"
import { Steps as JourneySteps } from "../steps/journey/step-library"
import { checkInExperienceSteps, checkInWorkflows } from "#/components/carrot-plans/check-in/workflow"
import { Sections, Workflows } from "#/components/carrot-plans/check-in/workflow.constants"
import { Redirect } from "react-router"
import { QueryStrings } from "#/utils/Paths"
import { useCurrentUser } from "#/components/context/user/UserContext"
import {
  CarrotPlanRequestType,
  useGetInProgressCarrotPlanRequestType
} from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import { Loading } from "#/components/views/Loading"
import { useIsMemberInSensitiveState } from "#/components/carrot-plans/hooks/useIsMemberInSensitiveState"

export default function CheckInExperienceRoutingFlow(): JSX.Element {
  useBodyClass("bg-warm-gray")
  const currentUser = useCurrentUser()
  const inProgressCarrotPlanRequestType = useGetInProgressCarrotPlanRequestType()
  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const isLoading = inProgressCarrotPlanRequestType.isLoading || cpRequestStatusQuery.isLoading
  const isMemberInSensitiveState = useIsMemberInSensitiveState()

  const needsToStartCheckInFlow =
    inProgressCarrotPlanRequestType.data !== CarrotPlanRequestType.CHECK_IN_INTAKE &&
    !cpRequestStatusQuery?.data?.carrotPlanIsOnTheWay &&
    !isMemberInSensitiveState

  const checkInExperienceSection = {
    name: Sections.CHECK_IN_EXPERIENCE,
    initialStep: JourneySteps.ARE_YOU_STILL_IN_THIS_PHASE,
    desiredWorkflow: Workflows.CHECK_IN_EXPERIENCE,
    steps: checkInExperienceSteps,
    workflows: checkInWorkflows
  }

  if (isLoading) {
    return <Loading />
  }

  if (currentUser?.isInAppLockdown) {
    return <Redirect to="/" />
  } else if (needsToStartCheckInFlow) {
    return <Redirect to={`/?dialog=${QueryStrings.CHECK_IN_CTA}`} />
  }

  return (
    <StateMachineProvider
      initialSection={Sections.CHECK_IN_EXPERIENCE}
      stateMachineDescription={[checkInExperienceSection]}
      onComplete={null}
    >
      <RoutingFlowContainer>
        <StateMachineStepView />
      </RoutingFlowContainer>
    </StateMachineProvider>
  )
}
